import { render, staticRenderFns } from "./WebsocketGreetings.vue?vue&type=template&id=bbe42d46"
import script from "./WebsocketGreetings.vue?vue&type=script&lang=js"
export * from "./WebsocketGreetings.vue?vue&type=script&lang=js"
import style0 from "./WebsocketGreetings.vue?vue&type=style&index=0&id=bbe42d46&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports